<div class="container new-session-wrapper">
    <div class="d-flex align-items-center mt-4 mb-3">
        <a class="btn btn-link text-muted" [routerLink]="'../'">Кабінет терапевта</a>
        <i class="bi bi-chevron-right"></i>
        <span class="ml-3">Додати замір</span>
    </div>
    <div class="row ">
        <div class="col-md-7">
            <h1>
                Оберіть замір
            </h1>
        </div>
        <div class="col-md-5">
            <p>
                Наші заміри пропонують глибоку оцінку вашого<br> психоемоційного стану, надаючи персоналізований аналіз.<br>Відмінно
                підходить для тих, хто хоче краще зрозуміти себе.
            </p>
        </div>
    </div>
    <div class="new-session-container">
        <div class="row">
            <div class="col-md-6 col-12">
                <h3>
                    Додати замір
                </h3>
            </div>
            <div class="col-md-6 col-12">
                <div class="search-wrapper">
                    <input class="search-input" placeholder="Пошук клієнта">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 col-12">
                <div class="mb-4">
                    <div class="selectedClients" *ngFor="let client of selectedClients; let i=index">
                        <div class="selectedClient">
                            <span class="badge badge-primary">{{client.clientName[0]}}</span>
                            {{client.clientName}}
                            <button class="btn p-0" (click)="removeClient(i)">
                                <i class="bi bi-x-lg"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <h5 class="mb-2">Оберіть клієнта</h5>
                <form [formGroup]="form">
                    <div class="mb-5">
                        <div class="mb-2">
                            <div class="input-group ">
                                <input formControlName="clientName" class="form-control"
                                       placeholder="Введіть ім’я та Прізвище клієнта">
                            </div>
                        </div>
                        <div class="mb-2">
                            <div class="input-group ">
                                <input formControlName="email" class="form-control" placeholder="Пошта клієнта">
                            </div>
                        </div>
                        <label>Посилання на замір</label>
                        <div class="mb-4">
                            <div class="input-group">
                                <input formControlName="link" type="text" class="form-control"
                                       placeholder="Пошта клієнта"
                                       aria-label="link"
                                       aria-describedby="basic-addon2">
                                <button class=" btn btn-link copy-btn bg-white">
                                    <i class="bi bi-copy"></i>
                                </button>
                            </div>
                        </div>
                        <button [disabled]="!form.valid" class="btn action-btn action-btn-outline"
                                (click)="addClient()">
                            Додати клієнта
                            <i class="bi bi-chevron-right"></i>
                        </button>
                    </div>
                </form>
                <h5 class="mb-2">Обрані заміри</h5>
                <div *ngIf="!selectedMeasures.length" class="border border-danger p-3 text-danger mb-4">
                    Ви ще не обрали жодного заміру
                </div>
                <div>
                    <div class="selectedClients" *ngFor="let client of selectedMeasures; let i=index">
                        <div class="selectedClient">
                            {{client.title}}
                            <button class="btn p-0" (click)="removeMeasure(i)">
                                <i class="bi bi-x-lg"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <button [disabled]="addMeasureDisabled" class="btn action-btn" (click)="addMeasures()">
                    Додати замір
                    <i class="bi bi-chevron-right"></i></button>
            </div>
            <div class="col-md-8 col-12">
                <div class="list-group">
                    <div class="list-group-item d-flex " *ngFor="let item of measuresPage">
                        <div class="left-side">
                            <div>
                                <h3>
                                    {{item.title}}
                                </h3>
                                <p class="text-muted mb-5">
                                    {{item.label}}
                                </p>
                            </div>
                            <button [disabled]="isItemSelected(item)" (click)="addMeasure(item)" class="btn action-btn action-btn-outline">
                                Обрати замір
                                <i class="bi bi-chevron-right"></i>
                            </button>
                        </div>
                        <div>
                            <lib-dast-renderer [dastNode]="item.description.value.document"></lib-dast-renderer>
<!--                            {{item.text}}-->
                        </div>
                    </div>
                </div>
                <app-reviews-pager *ngIf="measures.length" [perPage]="3" [data]="measures"
                                   (pageChange)="onPager($event)"></app-reviews-pager>
            </div>
        </div>
    </div>
</div>
